import { Routes } from '@angular/router';

export const BUSINESS_ROUTES: Routes = [
  { path: 'xero-callback', loadComponent: () => import('./components/xero-connect/xero-connect.component').then(m => m.XeroConnectComponent) },
  { path: ':id', loadComponent: () => import('./components/business-view/business-view.component').then(m => m.BusinessViewComponent) },
  { path: '', loadComponent: () => import('./components/business-list/business-list.component').then(m => m.BusinessListComponent) }
];
